export default __webpack_public_path__ + "static/media/jsFramework.6f29b198.svg";